import axios from "axios";
import store from "../store";
import { logoutSuccess, refreshAccessToken } from "../store/actions";
import { API_REFRESH_TOKEN } from "../constants/api";
import {API_BASE_URL} from "../configs/settings"

// Create new Instance of axios
const API = axios.create({
    baseURL: API_BASE_URL,
    maxRedirects: 0,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
    }
});

// Process before send request
API.interceptors.request.use(
    (config) => {
        const auth = store.getState().auth;
        if (auth && auth.access_token) {
            config.headers['Authorization'] = `Bearer ${auth.access_token}`;
        }
        if(config.url.endsWith('/')) {
            config.url = config.url.slice(0, -1);
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Process get refresh access_token
API.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        //Check if token expired error
        if (error.response?.status === 401 && originalRequest.url === API_REFRESH_TOKEN) {
            store.dispatch(logoutSuccess());
            return Promise.reject(error);
        }
        
        //Refresh the token access
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                const refreshToken = store.getState().auth.refresh_token;
                const response = await API.post(API_REFRESH_TOKEN, {refresh: refreshToken?? "no-token"})
                const accessToken = response.data.access;
                store.dispatch(refreshAccessToken(accessToken));
                API.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
                return API(originalRequest);
            } catch (refreshError) {
                store.dispatch(logoutSuccess());
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default API;